module.exports = __webpack_public_path__ + "img/incomplete.9c2ca05.png";